import { useState, useCallback } from 'react';
import sendChannelViewEvent from '@/helpers/api/events/sendChannelViewEvent';
import useCallApi from '@/hooks/api/useCallApi';

const useChannelEvent = ({
  channelId,
  recommendationId,
  recommendationType,
  shouldCall = false
}) => {
  const [eventSent, setEventSent] = useState(false);

  const handleSendShowViewEvent = useCallback(() => {
    setEventSent(true);
    
    return sendChannelViewEvent({
      channelId,
      recommendationId,
      recommendationType
    });
  }, [channelId, recommendationId, recommendationType]);

  useCallApi({
    call: handleSendShowViewEvent,
    shouldCall: !eventSent && shouldCall
  });
};

export default useChannelEvent;